import ApplicationController from './application_controller'

class Select2Controller extends ApplicationController {
  connect () {
    $(this.element).on('change', function () {
      const event = new Event('selected', { bubbles: true })
      this.dispatchEvent(event)
    })
  }

  clear_selectbox (event) {
    $(event.target.dataset.selector).val(null).trigger('change')
  }
}

export default Select2Controller
